/**
 * Spinner — the app's loading indicator: a circle with a gradient arc in the
 * accent colour that rotates. Shared so every "loading" state looks the same
 * (editor startup, the maps list, etc.).
 */

import React from 'react';

export default function Spinner({ size = 44, label }: { size?: number; label?: string }) {
  const ring = Math.max(3, Math.round(size * 0.11));
  const dot = (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        // Gradient arc: transparent → accent around the ring.
        background: 'conic-gradient(from 90deg, transparent 0deg, oklch(0.70 calc(0.205 * var(--accent-c)) var(--accent-h) / 0.15) 90deg, var(--accent) 330deg, transparent 360deg)',
        WebkitMask: `radial-gradient(farthest-side, transparent calc(100% - ${ring}px), #000 calc(100% - ${ring}px))`,
        mask: `radial-gradient(farthest-side, transparent calc(100% - ${ring}px), #000 calc(100% - ${ring}px))`,
        animation: 'vinyl-spin 0.9s linear infinite',
        filter: 'drop-shadow(0 0 6px oklch(0.70 calc(0.205 * var(--accent-c)) var(--accent-h) / 0.45))',
      }}
    />
  );
  if (!label) return dot;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
      {dot}
      <span style={{ fontSize: 12, color: 'var(--accent)', fontWeight: 600, letterSpacing: 0.4 }}>{label}</span>
    </div>
  );
}
